import React, { useEffect, useState } from "react";
import '../HomePage/HomeInsurance.css';
import '../HomePage/Quotes.css';
import ProposalFormDetail from "./ProposalFormDetail.jsx";
import ProposalForm from "./ProposalForm.jsx";
import HomePlan from "./HomePlan.jsx";
import OwnerDetail from "./OwnerDetail.jsx";
import HomeDetail from "./HomeDetail";
import { apiURL } from "../index";
import { useHistory } from "react-router-dom";
import { CommaSeprator } from "./UtilityComponents/UilityFunctions";



const Summary = ({ location }) => {
    const [PropReq, setPropReq] = useState(null);
    const [propRes, setPropRes] = useState(null);
    const [QuoteReq, setQuoteReq] = useState(null);
    const [QuoteRes, setQuoteRes] = useState(null);
    useEffect(() => {
        setPropReq(location?.state?.ProposalReq);
        setPropRes(location?.state?.ProposalRes);
        setQuoteReq(location?.state?.QuoteReq);
        setQuoteRes(location?.state?.QuoteRes);
    }, [])
        console.log(location);
    const history = useHistory();
    
    const gotoPayment = () => {
        window.location.href = `${apiURL}PG/GoToPayment?EnquiryNo=${PropReq.EnquiryNo}&InsurerID=${PropReq?.InsurerID}`;
    }
    return (
        <>
            <div className="HomePerposalPage HomePageMain summaryPageMain">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="backtoquotes">
                                <a onClick={()=> history.goBack()}>
                                    <i className="fa fa-chevron-left"></i>
                                    <span>Back to ProposalForm</span>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-9 Proposal1">
                            <HomeDetail data={{ ...PropReq, image:QuoteRes?.image }} />
                        </div>
                        <div className="col-lg-3 Proposal1">
                            <HomePlan QuoteReq={QuoteReq} QuoteRes={QuoteRes} />
                        </div>
                        <div className="col-lg-9 Proposal1">
                            <OwnerDetail data={PropReq} />   
                            <div className="view_quotes">
                                <button href="#proposal" type="submit" className="SMCLarg1" onClick={gotoPayment}>
                                    {/* <i className="fa fa-hand-o-right"></i>*/} Pay ₹ {CommaSeprator(Math.round(QuoteRes?.totalPremium))}<i className="fas fa-chevron-right"></i>
                                    
                                </button>
                                <div>
                                    <p className="mt-2">By clicking I agree to all<a href="https://www.smcinsurance.com/terms-of-use" target="_blank"><span className="green-text"> T&C</span></a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Summary;